const CampTypes = [
    { iconName: 'all-inclusive', text: 'All' },
    { iconName: 'sports-football', text: 'Football' },
    { iconName: 'sports-basketball', text: 'Basketball' },
    { iconName: 'pool', text: 'Swimming' },
    { iconName: 'sports-baseball', text: 'Baseball' },
    { iconName: 'sports-soccer', text: 'Soccer' },
    { iconName: 'sports-tennis', text: 'Tennis' },
    { iconName: 'sports-hockey', text: 'Hockey' },
    { iconName: 'pets', text: 'Pets' },
    { iconName: 'directions-run', text: 'Running' },
    { iconName: 'color-lens', text: 'Drawing' },
    { iconName: 'ice-skating', text: 'Ice Skating' },
    { iconName: 'sailing', text: 'Sailing' },
    { iconName: 'downhill-skiing', text: 'Skiing' },
    { iconName: 'sports-gymnastics', text: 'Gymnastics' },
    { iconName: 'skateboarding', text: 'Skateboarding' },
    { iconName: 'auto-stories', text: 'Religion' },
    { iconName: 'palette', text: 'Art' },
    { iconName: 'music-note', text: 'Music' },
    { iconName: 'restaurant', text: 'Cooking' },
    { iconName: 'science', text: 'Science' },
    { iconName: 'computer', text: 'Technology' },
    { iconName: 'terrain', text: 'Adventure' },
    { iconName: 'theater-comedy', text: 'Drama' },
    { iconName: 'camera-alt', text: 'Photography' },
    { iconName: 'celebration', text: 'Dance' },
    { iconName: 'self-improvement', text: 'Yoga' },
];

const normalizeCampCategoryValue = (value?: string | null) => String(value || '').trim().toLowerCase();

export const resolveCampType = (value?: string | null) => {
    const normalized = normalizeCampCategoryValue(value);

    if (!normalized) {
        return null;
    }

    return CampTypes.find((type) => {
        return normalizeCampCategoryValue(type.iconName) === normalized
            || normalizeCampCategoryValue(type.text) === normalized;
    }) || null;
};

export const getCampTypeIconName = (value?: string | null, fallback = 'terrain') => {
    return resolveCampType(value)?.iconName || fallback;
};

export const getCampTypeText = (value?: string | null, fallback = 'Adventure') => {
    return resolveCampType(value)?.text || fallback;
};

export const getCampTypeColor = (value?: string | null, fallback = 'hsl(200, 70%, 45%)') => {
    const normalized = normalizeCampCategoryValue(value);
    if (!normalized) return fallback;

    let hash = 0;
    for (let i = 0; i < normalized.length; i++) {
        hash = normalized.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 70%, 45%)`;
};

export default CampTypes;